/** 引导场景，决定打开助手时推荐哪些功能列表 */
export var GuideScene;
(function (GuideScene) {
    /** AI 新建文档 */
    GuideScene[GuideScene["CREATE_FROM_AI"] = 0] = "CREATE_FROM_AI";
    /** 非 AI 新建, 内容量少的文档 */
    GuideScene[GuideScene["POOR_CONTENT"] = 1] = "POOR_CONTENT";
    /** 非 AI 新建, 内容丰富的文档 */
    GuideScene[GuideScene["RICH_CONTENT"] = 2] = "RICH_CONTENT";
    /** AI 新建, 存在智能配图的文档（不用出推荐指令） */
    GuideScene[GuideScene["CREATE_FROM_AI_WITH_IMAGE"] = 3] = "CREATE_FROM_AI_WITH_IMAGE";
})(GuideScene || (GuideScene = {}));
//# sourceMappingURL=slide.js.map